import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRender = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 20,
	viewBox: "0 0 15 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_17396_28043)",
			children: [/* @__PURE__ */ _jsx("path", {
				opacity: .47,
				d: "M14.1742 9.18358L10.7601 6.87025L1.40509 0.950681C2.10764 1.76827 2.66228 2.70627 3.03205 3.73301C3.27855 4.39848 3.45111 5.08931 3.54355 5.78648L10.5567 10.3054C10.68 10.3941 10.7662 10.5335 10.797 10.6857C10.8279 10.8378 10.797 11.0025 10.7046 11.1293L10.68 11.1673L10.6553 11.199L10.6245 11.2307H10.606L10.5567 11.2687L3.78389 15.5151C3.69145 15.5785 3.58053 15.6038 3.47576 15.5785C3.37099 15.5595 3.27239 15.4961 3.21076 15.401C3.16763 15.3313 3.14297 15.2489 3.13681 15.1665V5.48226C3.04437 4.8865 2.8903 4.29708 2.68077 3.73301C2.19392 2.33234 1.34347 1.09011 0.221857 0.152109L0 0V18.2214C0 18.8742 0.351274 19.4763 0.912079 19.7868C1.47288 20.0974 2.15694 20.0657 2.68694 19.7108L14.1742 12.3525C14.6919 12.0039 15 11.4082 15 10.7744C15 10.1406 14.6857 9.54484 14.1742 9.19625V9.18358Z",
				fill: "#5590FF"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M14.1742 9.18358L10.7601 6.87025C11.3085 7.32658 11.6598 7.99206 11.7276 8.72091C11.7954 9.44343 11.5859 10.1659 11.136 10.73C11.0066 10.8948 10.8525 11.0469 10.6861 11.18L10.6615 11.2117L10.6306 11.2434L10.5813 11.2814L5.70666 14.2349L3.8332 15.5405C3.74076 15.6102 3.62366 15.6419 3.51274 15.6229C3.40181 15.6038 3.3032 15.5341 3.24158 15.4327C3.19844 15.363 3.17379 15.2806 3.16763 15.1982V5.50127C3.06902 4.89918 2.90263 4.30342 2.68694 3.73301C2.19392 2.33234 1.34347 1.09011 0.221857 0.152109L0 0V18.2214C0 18.8742 0.351274 19.4763 0.912079 19.7868C1.47288 20.0974 2.15694 20.0657 2.68694 19.7108L14.1742 12.3525C14.6919 12.0039 15 11.4082 15 10.7744C15 10.1406 14.6857 9.54484 14.1742 9.19625V9.18358Z",
				fill: "url(#paint0_linear_17396_28043)"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_17396_28043",
			x1: 0,
			y1: 10.0012,
			x2: 15,
			y2: 10.0012,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#5690FF" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .1,
					stopColor: "#4D8AFC"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .2,
					stopColor: "#4584F9"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .3,
					stopColor: "#3C7DF6"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .4,
					stopColor: "#3477F3"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#2B71F0"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .6,
					stopColor: "#226BEC"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7,
					stopColor: "#1A65E9"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .8,
					stopColor: "#115EE6"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .9,
					stopColor: "#0958E3"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0052E0"
				})
			]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_17396_28043",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 15,
				height: 20,
				fill: "white"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgRender);
export default ForwardRef;
